import { Injectable } from '@angular/core';
import AbstractAuthService from './abstract-auth.service';

@Injectable()
export default class SsoAuthService extends AbstractAuthService {
  protected authToken: string;
  protected submitNumberEndpoint = 'otpSso.send';
  protected submitPasswordEndpoint = 'otpSso.send';

  protected makeSubmitNumberData(): any {
    return {
      ssoToken: '',
      msisdn: this.msisdn,
    };
  }

  protected makeSubmitPasswordData(password: string): any {
    return {
      authToken: this.authToken,
      otp: password
    };
  }

  protected handleSubmitNumberResponse(submitNumberResponse: any): void {
    if (submitNumberResponse.status === '0') {
      this.authToken = submitNumberResponse.authToken;
      this.showPasswordModal();
      return;
    }

    this.showFailureModal();
    this.reject();
  }

  protected handleSubmitPasswordResponse(submitPasswordResponse: any): void {
    switch (submitPasswordResponse.status) {
      case '0':
        this.resolve();
        break;
      case '1':
        this.showPasswordErrorModal();
        break;
      default:
        this.showFailureModal();
        this.reject();
    }
  }
}
